export class DTOError extends Error {
  // поле которое принимает ожидаемое значение
  private _resultingValue: string;
  constructor(message: string, resultingValue: any) {
    super(message);
    this.name = 'DTOError';
    this._resultingValue = JSON.stringify(resultingValue);
  }
  get resultingValue(): string {
    return this._resultingValue;
  }
}
